import Vue from 'vue';
import { isLandscape, capitalize, capitalizeFirstLetter } from '@/utils/helpers';
import { Orientation } from '@/utils/index.model';
import moment from 'moment-timezone';

Vue.prototype.$screen = Vue.observable({
  width: window.innerWidth,
  height: window.innerHeight,
  orientation: isLandscape() ? Orientation.landscape : Orientation.portrait,
  visibility: !document.hidden,
});

window.addEventListener('resize', () => {
  Vue.prototype.$screen.width = document.documentElement.clientWidth;
  Vue.prototype.$screen.height = document.documentElement.clientHeight;
});

window.addEventListener('orientationchange', () => {
  Vue.prototype.$screen.orientation = isLandscape() ? Orientation.landscape : Orientation.portrait;
});

window.addEventListener(
  'visibilitychange',
  () => {
    Vue.prototype.$screen.visibility = !document.hidden;
  },
  false
);

Vue.prototype.$capitalize = (str: string, isFirstLetter: boolean = false): string => {
  if (!str) {
    return str;
  }
  return isFirstLetter ? capitalizeFirstLetter(str) : capitalize(str);
};

Vue.prototype.$moment = moment;
